import { CalendarClock } from "lucide-react";

const PT = "America/Los_Angeles";

export const fmtSlotTime = (iso) =>
  new Date(iso).toLocaleTimeString("en-US", { timeZone: PT, hour: "numeric", minute: "2-digit" }) + " PT";

export const SlotPicker = ({ slots, selected, onSelect, testPrefix = "slot" }) => {
  if (slots === null) return <p className="text-sm text-[#8A939B]">Loading available times…</p>;
  if (!slots.length)
    return (
      <p data-testid={`${testPrefix}-empty`} className="rounded-xl border border-amber-500/30 bg-amber-500/10 p-4 text-sm text-amber-300">
        No open times this week — new Mon/Wed/Fri slots open up regularly. Check back soon or email hello@hughlaunch.com.
      </p>
    );
  const days = {};
  slots.forEach((s) => {
    const key = new Date(s.start).toLocaleDateString("en-US", { timeZone: PT, weekday: "long", month: "long", day: "numeric" });
    (days[key] = days[key] || []).push(s);
  });
  return (
    <div className="space-y-4" data-testid={`${testPrefix}-picker`}>
      {Object.entries(days).map(([day, list]) => (
        <div key={day} className="rounded-2xl border border-[#1c1f25] bg-[#101216] p-4">
          <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-[#8A939B]">
            <CalendarClock className="h-4 w-4 text-[#C6FF00]" /> {day}
          </p>
          <div className="flex flex-wrap gap-2">
            {list.map((s) => (
              <button key={s.id} type="button" data-testid={`${testPrefix}-${s.id}`} onClick={() => onSelect(s.id)}
                className={`rounded-full border px-4 py-2 text-sm font-bold transition-colors ${selected === s.id ? "border-[#C6FF00] bg-[#C6FF00] text-[#0A0C0F]" : "border-[#23262c] bg-[#14161b] text-white hover:border-[#C6FF00]"}`}>
                {fmtSlotTime(s.start)}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
